import React, { useState, useEffect } from "react";
import Spinner from "../../common/Spinner";
import invoicesApiClient, { InvoiceStatus } from "../../clients/InvoicesApiClient";
import { formatDate, formatDateTime } from "../../utils/formatDate";
import formatPrice from "../../utils/formatPrice";
import { createAuctionItemDescription } from "../invoices/MyInvoices";
import { ApiClient } from "../../ApiClient";
const apiClient = new ApiClient('/api/payments');
export function Invoice(props) {
    const [invoice, setInvoice] = useState();
    const fetchData = async () => {
        try {
            setInvoice(await invoicesApiClient.getInvoice(props.type, props.id));
        }
        catch {
            history.back();
        }
    };
    const payInvoice = async () => {
        const returnUrl = await apiClient.post('/pay', {
            type: props.type,
            invoiceIdentifier: props.id,
        });
        window.location.replace(returnUrl);
    };
    useEffect(() => {
        void fetchData();
    }, []);
    if (!invoice) {
        return (React.createElement(Spinner, null));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "invoice-header" },
            React.createElement("h2", null, "Faktura"),
            React.createElement("h5", null,
                "CIN/",
                props.id)),
        React.createElement("div", { className: "two-cols" },
            React.createElement("table", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Fakturaadresse")),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        invoice.invoiceAddress.name,
                        " ",
                        invoice.invoiceAddress.firstName)),
                React.createElement("tr", null,
                    React.createElement("td", null, invoice.invoiceAddress.addressLine1)),
                React.createElement("tr", null,
                    React.createElement("td", null, invoice.invoiceAddress.addressLine2)),
                React.createElement("tr", null,
                    React.createElement("td", null, invoice.invoiceAddress.city)),
                React.createElement("tr", null,
                    React.createElement("td", null, invoice.invoiceAddress.postalCode))),
            React.createElement("table", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Leveringsadresse")),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        invoice.shippingAddress.name,
                        " ",
                        invoice.shippingAddress.firstName)),
                React.createElement("tr", null,
                    React.createElement("td", null, invoice.shippingAddress.addressLine1)),
                React.createElement("tr", null,
                    React.createElement("td", null, invoice.shippingAddress.addressLine2)),
                React.createElement("tr", null,
                    React.createElement("td", null, invoice.shippingAddress.city)),
                React.createElement("tr", null,
                    React.createElement("td", null, invoice.shippingAddress.postalCode)))),
        React.createElement("table", null,
            React.createElement("tr", null,
                React.createElement("th", { colSpan: 4 }, "Ordreinformasjon")),
            React.createElement("tr", null,
                React.createElement("td", null, "Ditt nummer:"),
                React.createElement("td", null, invoice.customerReferenceNumber),
                React.createElement("td", null, "Dato"),
                React.createElement("td", null, formatDateTime(invoice.createdAt))),
            React.createElement("tr", null,
                React.createElement("td", null, "Din referanse:"),
                React.createElement("td", null, invoice.customerReference),
                React.createElement("td", null, "Forsendelsesm\u00E5te:"),
                React.createElement("td", null)),
            React.createElement("tr", null,
                React.createElement("td", null, "KID:"),
                React.createElement("td", null, invoice.sellersPaymentReference),
                React.createElement("td", null, "Betalingsbetingelser:"),
                React.createElement("td", null, invoice.paymentTerms)),
            React.createElement("tr", null,
                React.createElement("td", null, "Bankkontonummer:"),
                React.createElement("td", null, props.skanfilAccountNumber),
                React.createElement("td", null, "Forfallsdato:"),
                React.createElement("td", null, formatDate(invoice.paymentDueDate))),
            React.createElement("tr", null,
                React.createElement("td", null, "V\u00E5rt nummer:"),
                React.createElement("td", null, invoice.sellersReferenceNumber))),
        React.createElement("table", null,
            React.createElement("tr", { className: "no-break" },
                React.createElement("th", { className: "text-center" }, "Antall"),
                React.createElement("th", { className: "text-center" }, "Varenr"),
                React.createElement("th", null, "Beskrivelse"),
                React.createElement("th", { className: "text-right" }, "Stk.pris"),
                React.createElement("th", { className: "text-right" }, "Totalt")),
            invoice.items.map(row => React.createElement("tr", { key: row.id },
                React.createElement("td", { className: "text-center" }, row.quantity),
                React.createElement("td", { className: "text-center" }, row.name),
                React.createElement("td", { title: row.description }, createAuctionItemDescription(row)),
                React.createElement("td", { className: "text-right" }, formatPrice(row.price)),
                React.createElement("td", { className: "text-right" }, formatPrice(row.total))))),
        React.createElement("div", { className: "sum-total" },
            React.createElement("table", { className: "text-right", style: { width: "auto", borderTop: "1px solid black" } },
                invoice.freight && React.createElement("tr", null,
                    React.createElement("td", null, "Frakt:"),
                    React.createElement("td", null, formatPrice(invoice.freight))),
                invoice.fee && React.createElement("tr", null,
                    React.createElement("td", null, "Sal\u00E6r:"),
                    React.createElement("td", null, formatPrice(invoice.fee))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Sum:"),
                    React.createElement("td", null, formatPrice(invoice.subTotalAmount))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Mva:"),
                    React.createElement("td", null, formatPrice(invoice.vatAmount))),
                React.createElement("tr", { style: { borderTop: "1px solid black" } },
                    React.createElement("td", null, "Sum totalt:"),
                    React.createElement("td", null, formatPrice(invoice.totalAmount))))),
        React.createElement("div", { className: "button-section" },
            invoice.status === InvoiceStatus.PendingPayment && React.createElement("button", { className: "button button-small btn primary", onClick: payInvoice }, "Betal"),
            invoice.status === InvoiceStatus.PendingPaymentConfirmation && React.createElement("strong", null, "Venter p\u00E5 bekreftelse"),
            invoice.status === InvoiceStatus.ConfirmedPaid && React.createElement("strong", null, "Bekreftet betalt"))));
}
